module.exports = __webpack_public_path__ + "img/email-outlined.e0959d17.svg";